import s2_3_1_sect2_img1 from '../../../../assets/images/s2_3_1_sect2_img1.png';
import s2_3_1_sect2_img2 from '../../../../assets/images/s2_3_1_sect2_img2.png';
import s2_3_1_sect2_img3 from '../../../../assets/images/s2_3_1_sect2_img3.png';
import s2_3_1_sect2_img4 from '../../../../assets/images/s2_3_1_sect2_img4.png';

import s2_3_1_sect3_img from '../../../../assets/images/s2_3_1_sect3_img.png';

import ProductSlider from '../../common/ProductSlider';
import FixedButton from '../../common/FixedButton';
import GoContact from '../../common/GoContact';

export default function Content() {
  return (
    <>
      <GoContact />

      <div className="s2_1_1_sect2 pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">특징</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">강력한 성능의 C30</p>
        </div>
        <div className="center">
          <div className="col-flex mb-5">
            <div className="row-flex-center between mb-4 m-col-flex ">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_3_1_sect2_img1} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-48 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3">
                  다양한 기능, 프로페셔널 클린
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  바닥 청소, 먼지 흡입, 먼지 퍼지 청소 및 기타 요구 사항을{' '}
                  <br />
                  동시에 수행할 수 있으며 흡입력이 큰 모니터가 장착된
                  <br />
                  일반쓰레기는 청소할 수 있습니다.
                </p>
              </div>
            </div>

            <div className="row-flex-center between mb-4 m-col-flex ">
                  <div className="s2_1_1_sect2_item w-48 m-w-100 pc-none t-none">
                <img src={s2_3_1_sect2_img2} alt="" />
              </div>
              <div className="s2_1_1_sect2_item w-48 txt-right m-w-100">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                편리하고 사용자 친화적
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
         손잡이가 장착된 화면, 사용자 친화적 인터페이스 및 빠른 분해 설계로 <br  className='t-none'/>
로봇은 사용하기 편리하고 운영이 쉽습니다.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-w-100 m-none">
                <img src={s2_3_1_sect2_img2} alt="" />
              </div>
            </div>

            <div className="row-flex-center between mb-4 m-col-flex">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_3_1_sect2_img3} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-48 txt-left m-w-100">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">스마트하고 민첩한 <br />
안정 보호 기능</p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                3D 비전과 지능적으로 장애물 회피 기능을 갖춘 이 로봇은<br />
사람들 속에서 민첩하게 이동할 수 있으며<br />
작동에 대해서 안정성을 보장합니다.
                </p>
              </div>
            </div>

            <div className="row-flex-center between m-col-flex">
              <div className="s2_1_1_sect2_item w-48 m-w-100 pc-none t-none">
                <img src={s2_3_1_sect2_img4} alt="" />
              </div>
              <div className="s2_1_1_sect2_item w-48 txt-right m-w-100">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
              자동충전
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
               로봇 사용 시간을 사용 일정에 따라 구성할 수 있습니다.<br />
사용후에 자동으로 충전소로 돌아가 사용시간 동안 걱정없이 운영할 수 있도록<br className='t-none'/>
최적의 에너지(배터리)를 보호합니다.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-w-100 m-none
              ">
                <img src={s2_3_1_sect2_img4} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="s2_1_1_sect3 pt-10">
        <div className="center">
    <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">제품 사양</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">
            로봇의 상세 스펙을 확인하세요
          </p>
        </div>

        <div className="flex-center mb-4">
          <img src={s2_3_1_sect3_img} alt="" />
        </div>

        <div className="">
          <div className="flex-center col-flex">
            <div className="s2_1_1_sect3_inner w-60 mb-5 m-w-100 t-w-100">
              <div className="row-flex-center between s2_1_1_sect3_inner_box">
                <div className="item col-flex flex-center gap-10">
                  <p className="prt-regular fs-16 fc-a4">제품무게</p>
                  <p className="prt-bold fs-28 fc-black1">35,30kg</p>
                </div>

                <div className="item col-flex flex-center gap-10">
                  <p className="prt-regular fs-16 fc-a4">최대 운행 속도</p>
                  <p className="prt-bold fs-28 fc-black1">0.8 m/s</p>
                </div>

                <div className="item col-flex flex-center gap-10">
                  <p className="prt-regular fs-16 fc-a4">청소효울</p>
                  <p className="prt-bold fs-28 fc-black1">600 m2/h</p>
                </div>

                <div className="item col-flex flex-center gap-10">
                  <p className="prt-regular fs-16 fc-a4">최대 청소 폭</p>
                  <p className="prt-bold fs-28 fc-black1">61.0cm</p>
                </div>
              </div>
            </div>

            <div className="s2_1_1_sect3_inner2 w-70 mb-10 m-w-100 t-w-100">
              <div className="row-flex between m-col-flex w-100 lh-14 s2_1_1_sect3_inner2_box">
                <div className="left w-48 m-w-100 ">
                  <div className="item ">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                        제품크기
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                   49.5 × 52.0 × 75.0cm <br />
(19.29” × 20.47” × 29.53”)

                      </p>
                    </div>
                  </div>

                  <div className="item min-h-85 ">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                     최대운행속도
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                  0.8 m/s (2.63 ft/s)
                      </p>
                    </div>
                  </div>

                  <div className="item ">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                    배터리 수명*
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                최대 6시간 (진공청소 및 쓸기모드) <br />
최대 10시간 (먼지 쓸기 모드)
                      </p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
            최대 청소 폭***
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                    61.0cm (24.02”)
                      </p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                    최대흡입력
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                    19000 Pa
                      </p>
                    </div>
                  </div>
                </div>

                <div className="right w-48 m-w-100">
                  <div className="item min-h-85">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                제품무게
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                35kg (77 Ibs),배터리 있음 <br />
30kg (66 Ibs),배터리 없음
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                     청소모드
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                      진공청소 모드 <br />
먼지쓸기 모드
                      </p>
                    </div>
                  </div>

                  <div className="item min-h-85 ">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
       충전시간**
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                        5~6 시간
                      </p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
               청소효율
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
         600 m2/h (6458.35ft/h)
                      </p>
                    </div>
                  </div>
                  <div className="item ">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                  소음
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                  ≤ 70db
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sub_desc prt-light fs-14 fc-888 txt-left lh-15">
        *다양한 요인에 따라 모든 배터리 사양이 달라질 수 있으며, 실제 결과와 다를 수 있습니다. <br />
배터리 충전 주기는 제한적이며, 교체가 필요할 수 있습니다. 배터리 수명과 충전주기는 사용 및 설정에 따라 다를 수 있습니다.  <br />
 <br />
**표시된 충전 시간은 충전기 또는 충전 스테이션을 통해 배터리 잔량 15%부터 100%까지 충전에 걸리는 시간을 의미합니다. <br />
충전 중에는 로봇의 전원을 켜두셔야합니다. 로봇에 물이 묻은 상태에서는 절대 충전을 하지 마십시오. <br />
 <br />
***양쪽 측면 브러쉬와 메인 브러쉬 사용시를 기준으로 측정되었습니다.

 
              </div>
            </div>
          </div>
        </div>
        </div>
    
      </div>

      <ProductSlider></ProductSlider>
      <FixedButton></FixedButton>
    </>
  );
}
